import axios from 'axios';
import { CreateScenarioInput } from 'views/bluviu-nutrition/features/scenarios-v2/types/create-scenario-input.type';
import { ScenarioCloneInput } from 'views/bluviu-nutrition/features/scenarios-v2/types/scenario-clone-input.type';
import { Scenario } from 'views/bluviu-nutrition/features/scenarios-v2/types/scenario.type';

export const createScenario = async (globalCompnyId: string, globalSiteId: string, request: CreateScenarioInput): Promise<string> => {
  const res = await axios.post<string>(
    `/ewosapi/v1/scenarios/gt2-multi?globalCompanyId=${globalCompnyId}&globalSiteId=${globalSiteId}`,
    request
  );

  return res.data;
};

export const cloneScenario = async (globalCompanyId: string, scenarioId: string, request: ScenarioCloneInput): Promise<Scenario> => {
  const res = await axios.post<Scenario>(
    `/ewosapi/v1/scenarios/gt2-multi/${scenarioId}/clone?globalCompanyId=${globalCompanyId}`,
    request
  );

  return res.data;
};
